/**
 * 最终订货接口列表
 */
import Vue from "vue"
import axios from '@/utils/http'; // 导入http中创建的axios实例
const api = {
    //页面初始化
    init() {
      return axios.get(`${Vue.prototype.$base.API_PATH}/lastorder/inittemplate`);
    },
    //得到最终订货订货日期集合
    lastorderDates(params) {
      return axios.get(`${Vue.prototype.$base.API_PATH}/lastorder/date`);
    },
    //检索数据
    search(params) {
      return axios.get(`${Vue.prototype.$base.API_PATH}/lastorder/list` ,{ params: params});
    },
    //打印数据获取
    print(params) {
      return axios.get(`${Vue.prototype.$base.API_PATH}/lastorder/print` ,{ params: params});
    }
}

export default api;



// WEBPACK FOOTER //
// ./src/api/lastorder.js